import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M11.827 16.846a2.077 2.077 0 1 0 0 4.154 2.077 2.077 0 0 0 0-4.154m0-6.923a2.077 2.077 0 1 0 0 4.154 2.077 2.077 0 0 0 0-4.154m2.077-4.846a2.078 2.078 0 0 0-3.546-1.469 2.078 2.078 0 0 0 2.264 3.388 2.08 2.08 0 0 0 1.282-1.92"
    }, null, -1)
  ]))]))
}
export default { render: render }